import React from 'react';
import OrderPage from './components/OrderPage';
import { orderStatus } from '../../../constants/orderStatus';

const HyperLocalPickup = () => {
  const bulkActionOptions = [
    {
      label: 'Picked Up',
      value: 'pickedUp',
    },
    {
      label: 'Cancel',
      value: 'cancelOrder',
    },
    {
      label: 'Generate Manifest',
      value: 'Generate Manifest',
    },
  ];
  return (
    <div>
      <OrderPage
        type={orderStatus.readyForPickup}
        bulkActionOptions={bulkActionOptions}
        isHyperLocal={true}
      />
    </div>
  );
};

export default HyperLocalPickup;
